var Iframe_default = {
  "iframe": "Je86o"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
